<template>
  <div class="container">
    <p>（1）、访问网址：jyx.cxstar.cn</p>
    <p>（2）、登录方式</p>
    <p>学校IP范围内直接访问网址：jyx.cxstar.cn</p>
    <p>
      校外登录：需要在IP范围内注册完账号或者对接统一认证之后，在校外通过相关账号进行登录访问。
    </p>
    <div><img src="../../assets/images/newhelp/help1.png" /></div>
  </div>
</template>
<script>
export default {
  name: "Page1",
  data() {
    return {
      isProd: false,
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.container {
  padding: 75px;
  p,
  img {
    margin-bottom: 15px;
    font-size: 18px;
    max-width: 100%;
  }
}
</style>
